import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'
import {AccessFilterImageComponent} from './access-filter-image.component'

@NgModule({
  declarations: [AccessFilterImageComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
  ],
  exports: [
    AccessFilterImageComponent
  ]
})
export class AccessFilterImageModule {
}
